import { createSelector } from "@reduxjs/toolkit"
import { RootState } from "../../"

export const selectNotificationCounts = (state: RootState) => state.notifications.counts

export const selectSubscriptionsHealthy = (state: RootState) =>
  state.notifications.subscriptionsHealthy

export const selectTotalNotificationCount = createSelector(
  selectNotificationCounts,
  ({ failedOps, approvalOps, failedWorkflows, customStateCounts }) =>
    failedOps +
    approvalOps +
    failedWorkflows +
    customStateCounts.reduce((sum, { count }) => sum + count, 0)
)
